/* =====================================================================
 * Add Sample
 * ===================================================================*/

(function (doc) {

  const app = doc.querySelector('#app');
  if (!app) return;

  const dataClass = 'app-data';
  const dataSelector = '.' + dataClass;
  let rowContent = app.querySelector(dataSelector).innerHTML;

  /* ---------------------------------------------------------------------
   * 1. Add Sample
   * -------------------------------------------------------------------*/

  const addSample = () => {
    const table = app.querySelector('table tbody');
    const rows = app.querySelectorAll(dataSelector);
    const length = rows.length;

    rowContent = rowContent.split('Amostra ' + length).join('Amostra ' + (length + 1));

    const newRow = doc.createElement('tr');
    newRow.className = dataClass;
    newRow.innerHTML = rowContent;

    const tableRows = table.querySelectorAll('tr');
    table.insertBefore(newRow, tableRows[tableRows.length - 1]);
  };

  const btnAddSample = app.querySelector('.js-addSample');
  if (btnAddSample) {
    btnAddSample.addEventListener('click', () => addSample());
  }

  /* ---------------------------------------------------------------------
   * 2. Remove Sample
   * -------------------------------------------------------------------*/

  const removeSample = () => {
    const table = app.querySelector('table tbody');
    const rows = table.querySelectorAll(dataSelector);

    if (rows.length === 1) return;

    table.removeChild(rows[rows.length - 1]);
  };

  const btnRemoveSample = app.querySelector('.js-removeSample');
  if (btnRemoveSample) {
    btnRemoveSample.addEventListener('click', () => removeSample());
  }


}(document));
